import { useState, useEffect, useCallback } from "react";
import { Toast } from "../../../../config/Toast";
import { toast } from "react-toastify";
import Button from "../../../../components/Button";
import OngoingItem from "../tableOngoing/OngoingItem";
import DetailServices from "../../../../services/DetailDeduction";

const Detail = ({ data, activeModal, closeModal, editHandler, imageHandler }) => {
  const [loading, setLoading] = useState(false);
  const [dataRow, setDataRow] = useState([]);
  const installment = 0;

  const notify = useCallback((msg, type = "success") => {
    const fn = type === "success" ? toast.success : toast.error;
    fn(msg, Toast);
  }, []);

  const fetchDetailData = useCallback(
    async (id, installmentValue) => {
      try {
        setLoading(true);
        const { data: res } = await DetailServices.detailInstallment(id, installmentValue);
        setDataRow(res?.data || []);
      } catch (err) {
        console.error(err);
        notify("Gagal memuat data rekapitulasi", "error");
      } finally {
        setLoading(false);
      }
    },
    [notify]
  );

  useEffect(() => {
    if (activeModal && data?.id) {
      fetchDetailData(data.id, installment);
    }
  }, [activeModal, data?.id, installment, fetchDetailData]);

  const activeClass = activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingRight: "17px" } : {};

  return (
    <div className={`modal fade ${activeClass}`} id="modalDetailKasbon" style={activeStyle} role="dialog" aria-modal="true">
      <div className="modal-dialog modal-dialog-scrollable modal-xl text-center modal-dialog-centered" role="document">
        <div className="modal-content modal-content-demo">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">{`Detail Cicilan | ${data?.worker_name || "-"}`}</h5>
            <button aria-label="Close" className="btn-close" data-bs-dismiss="modal" onClick={closeModal}>
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pb-7">
            {loading ? (
              <div className="text-center py-5">Memuat data...</div>
            ) : dataRow.length > 0 ? (
              dataRow.map((d, index) => (
                <OngoingItem key={index} data={d} editHandler={editHandler} imageHandler={imageHandler} />
              ))
            ) : (
              <div className="text-center py-4 text-muted">Tidak ada data ditemukan.</div>
            )}

            <div className="text-end mt-4">
              <Button button="btn-gray ms-4 px-7" title="Tutup" onClick={closeModal} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
